module.exports = __webpack_public_path__ + "static/img/plug1.20f64169.png";